import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import BorderLinearProgress from "../progess/borderLinearProgress";
import { useTranslation } from "react-i18next";
import nerdUII18n from "../../i18n";
let direction = undefined;
/**
 *
 * @param {NerdNotificationProps & openHookAction} param0 components props
 * @returns {JSX.Element} NonIntrusive nerdNotifier
 */
export function NonIntrusive({ uuid, title, transition = "up", severity = "info", subtitle, body, position = {
    vertical: "bottom",
    horizontal: "right",
}, actions, autoHideDuration = 5000, autohide = true, open, handleClose, icon, color, }) {
    direction = transition;
    const [progress, setProgress] = React.useState(0);
    const { t } = useTranslation("common", { i18n: nerdUII18n });
    const timer = React.useRef(0);
    React.useEffect(() => {
        timer.current = window.setInterval(() => {
            setProgress((prevProgress) => prevProgress >= 100 ? 0 : prevProgress + 10);
        }, autoHideDuration / 10);
        return () => {
            clearInterval(timer.current);
        };
    }, []);
    React.useEffect(() => {
        if (progress >= 100 && autohide) {
            handleClose();
        }
    }, [progress, autohide]);
    if (icon) {
        return (_jsx(Alert, { severity: "warning", sx: {
                position: "absolute",
                width: "30%",
                bottom: 0,
                right: "10px",
            }, children: t("global.unknown") }));
    }
    return (_jsx(Box, { component: "div", id: uuid, children: _jsx(Snackbar, { open: open, autoHideDuration: autohide ? autoHideDuration : null, TransitionComponent: Transition, anchorOrigin: position, children: _jsxs(Stack, { spacing: 1, children: [autohide && (_jsx(BorderLinearProgress, { variant: "determinate", value: progress, color: severity })), _jsxs(Alert, { severity: severity, sx: { width: "100%", alignItems: "center", backgroundColor: color }, action: actions, onClose: handleClose, children: [title && (_jsx(Typography, { color: "white", variant: "body1", children: title })), subtitle && (_jsx(Typography, { color: "white", variant: "body2", children: subtitle })), body && (_jsx(Typography, { color: "white", variant: "caption", children: body }))] })] }) }) }));
}
const Alert = React.forwardRef(function Alert(props, ref) {
    return _jsx(MuiAlert, { ref: ref, variant: "filled", ...props });
});
/**
 *
 * @param {TransitionProps} props Component props
 * @returns {JSX.Element} Transition Component
 */
function Transition(props) {
    return _jsx(Slide, { ...props, direction: direction });
}
